import * as z from "zod";

export const createTemuIntegration = {
  name: "createTemuIntegration" as const,
  input: z.object({
    /** OAuth `code` from the Temu authorization callback. */
    code: z.string(),
    /** `callback_host` query param from the callback (authoritative API host). */
    callbackHost: z.string(),
    isOmsEnabled: z.boolean(),
    isReturnsEnabled: z.boolean(),
  }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().nullish(),
  }),
};
